<div class="h-screen bg-white relative flex flex-col justify-center items-center">
  <div class="card text-center">
    <img class="mb-4" src="assets/404.svg" alt="404 Not Found">
    <h1 class="text-blue-500 text-xl md:text-3xl font-bold mb-4">404 Not Found</h1>
    <p class="text-blue-100 text-2xl md:text-4xl font-bold">Opss! La página que buscas no existe</p>
  </div>
</div>
